import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useJamRoom } from '../hooks/useJamRoom.jsx';

/** Pila de notificaciones Material sobre la barra de reproducción. */
export default function Toasts() {
  const { toasts, dismissToast } = useJamRoom();
  if (!toasts.length) return null;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        left: { xs: 12, md: 24 },
        right: { xs: 12, sm: 'auto' },
        bottom: 'calc(var(--player-h) + 12px)',
        zIndex: (t) => t.zIndex.snackbar,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: { sm: 380 },
        maxWidth: 'calc(100vw - 24px)',
      }}
    >
      {toasts.map((t) => (
        <Alert
          key={t.id}
          severity={t.kind === 'error' ? 'error' : t.kind === 'ok' ? 'success' : 'info'}
          variant="filled"
          onClose={() => dismissToast(t.id)}
          sx={{ boxShadow: 8, alignItems: 'center' }}
        >
          {t.message}
        </Alert>
      ))}
    </Box>
  );
}
